import { CopyOutlined, DownloadOutlined, ExportOutlined } from 'yoc-ui-library/icons';

import type { IReportAction } from './types';

export const APP_CONFIG = {
  API_URL_REPORTING: 'https://deal-vault-auth-qa-509855967780.europe-west3.run.app',
};

export const SECTION_LABELS: Record<string, string> = {
  intro: 'INTRO',
  overview: 'OVERVIEW',
  performance_kpi: 'KPI SUMMARY',
  cost: 'MEDIA COST',
  creatives: 'CREATIVES',
  studio: 'STUDIO',
  all_approaches: 'SOLUTIONS',
  ias_metrics: 'IAS METRICS',
  summary: 'SUMMARY',
  contact: 'CONTACT',
};

export enum E_SECTION_MODE {
  SINGLE = 'single',
  MULTI = 'multi',
}

export const EXTERNAL_LINKS = {
  'yoc.com': 'https://yoc.com',
  'Privacy Policy': 'https://yoc.com/privacy',
  Imprint: 'https://yoc.com/imprint',
  Contact: 'https://yoc.com/contact',
  Accessibility: 'https://yoc.com/accessibility-at-yoc',
};

// TODO: Recheck if this is needed in the future
export const subsectionConfig: Record<string, E_SECTION_MODE> = {
  // creatives: E_SECTION_MODE.MULTI, TODO: is this really necessary?
  creatives: E_SECTION_MODE.SINGLE,
};

export enum E_DEVICE_TYPE {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

export enum E_DESKTOP_FRAME_CONFIGS {
  WIDTH = 1972,
  HEIGHT = 1282,
  MAX_SCALE = 0.5,
}

export enum E_MOBILE_FRAME_CONFIGS {
  WIDTH = 426,
  HEIGHT = 828,
  MAX_SCALE = 0.75,
}

export enum E_LANDSCAPE_SCALE_LIMITS {
  MIN = 0.4,
  MAX = 0.6,
}

export enum E_PORTRAIT_SCALE_LIMITS {
  MIN = 0.2,
  MAX = 0.5,
}

export enum E_CREATIVE_TYPE {
  SIMPLE = 'simple',
  GROUPED = 'grouped',
}

export enum E_THEME {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum E_REPORT_ACTIONS_LAYOUT {
  LIST = 'list',
  GRID = 'grid',
}

export enum E_LANGUAGE {
  EN = 'EN',
  DE = 'DE',
}

export const DISABLED_LANGUAGES: E_LANGUAGE[] = [E_LANGUAGE.DE];

export const REPORT_SCROLL_ID = 'report-viewport';

export const REPORT_ACTIONS: IReportAction[] = [
  {
    icon: <CopyOutlined />,
    title: 'Copy URL',
  },
  {
    icon: <DownloadOutlined />,
    title: 'Export XLS',
  },
  {
    icon: <DownloadOutlined />,
    title: 'Export PDF',
  },
  {
    icon: <ExportOutlined />,
    title: 'View Demo',
    href: '',
  },
];

export const SCROLL_TIMEOUT = 300;
export const SHARED_DEVICE_SCALE_MULTIPLIER = 1.45;
